import { emptyFragment } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { previewStore } from '../LearningCollectionPreviewStore';
import ErrorMessage from './ErrorMessage';
import HeaderSkeleton from './HeaderSkeleton';
import HeaderView from './HeaderView';
import SaveCollection from '../Previewer/Ready/Details/DefaultSection/SaveCollection';

function Header() {
  switch (previewStore.state.kind) {
    case 'error':
    case 'waiting':
    case 'discarding-changes':
      return emptyFragment();
    case 'saving-from-publishing':
    case 'saving-from-creating':
    case 'saving-from-save-and-editing':
    case 'loading':
      return <HeaderSkeleton />;
    case 'ready':
    case 'recommendations-incoming':
    case 'publishing':
    case 'creating':
    case 'save-and-editing':
    case 'confirming-cancel':
    case 'confirming-cancel-from-publish':
    case 'confirming-cancel-from-create':
    case 'confirming-cancel-from-save-and-edit':
    case 'publish-celebration':
    case 'save-celebration':
      return (
        <HeaderView>
          <ErrorMessage />
          <SaveCollection />
        </HeaderView>
      );
  }
}

export default observer(Header);
